import React, { useEffect, useState } from "react";
import { FetchHandler } from "../../Handlers/FetchHandler";
import { ForumPostCard } from "../Forum/ForumPostCard";
import { AdminIcons } from "../Shared/AdminIcon";
import { ToolBar } from "../ToolBar/ToolBar";
import { LoadingBar, ScreenHeader, ScreenMenu } from "../UI/Elements";
import { useElasticMenu } from "./useElasticMenu";
import { useElasticSearch } from "./useElasticSearch";

export const ElasticSearchBlog = () => {
    const ui = useElasticSearch();

    // useEffect(() => {
    //     ui.load();
    // }, []);

    const [search, setSearch] = useState<string>(undefined);
    const menu = useElasticMenu();

    return (
        <div className="screen-elastic">
            <ScreenHeader text="Appsök blog med Elastic Search" icon={AdminIcons.user} />
            <ScreenMenu items={menu?.items} />

            <LoadingBar loading={ui.loadingBlogs} />
            <div>
                <input placeholder="Sök..." className="frm" type={"search"} value={search} onChange={e => setSearch(e.target.value)} onKeyUp={e => {
                    if (e.key === "Enter") {
                        ui.onSearchBlogs(search);
                    }
                }} />
            </div>

            <div>
                <div>
                    Träffar: {ui?.blogs?.total ?? 0} - Svarstid: {ui.blogs?.durationms} ms.
                </div>
                {/* <div>

                    {(ui.blogs?.suggestions?.length > 0) && (
                        <div className="suggestions-container">
                            <label>
                                Menade du?
                            </label>

                            <div className="suggestions">
                                {(ui.blogs?.suggestions?.length > 0) && ui.blogs?.suggestions?.map(s => (
                                    <div className="suggestion" key={s} onClick={() => {
                                        ui.onSearchBlogs(s);
                                        setSearch(s);
                                    }} >
                                        {s}
                                    </div>
                                ))}
                            </div>
                        </div>
                    )}

                </div> */}
                <table className="tbl tbl-small">
                    <thead>
                        <tr>
                            <th>Rubrik</th>
                            <th>Datum</th>
                            <th>Excerpt</th>
                        </tr>
                    </thead>
                    <tbody>
                        {ui.blogs?.hits?.map(hit => (
                            <tr key={hit?.id}>
                                <td>{hit?.titlehtmldecoded}</td>
                                <td>{hit?.publisheddatetime}</td>
                                <td>{hit?.htmlexcerptdecoded}</td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
        </div>
    )
}
